import type { ReactNode } from "react";
import { Container } from "@/components/ui/Container";
import { Prose } from "@/components/ui/Prose";
import {
	CustomerServiceForm,
	type CustomerServiceFormContent,
} from "@/components/ui/sections/CustomerService/CustomerServiceForm";
import { Typography } from "@/components/ui/Typography";
import type { CustomerServiceStoryblok } from "@/generated/sb/sb-types";

export interface CustomerServiceProps {
	heading?: string;
	intro?: ReactNode;
	consent?: ReactNode;
	topics: CustomerServiceStoryblok["topics"];
	content?: CustomerServiceFormContent;
}

export const CustomerService = ({
	heading,
	intro,
	consent,
	topics,
	content,
}: CustomerServiceProps) => {
	return (
		<section className="py-grid-section-vertical-lg">
			<Container>
				<div className="grid grid-cols-12 gap-[var(--layout-gap)]">
					{heading && (
						<Typography
							variant="heading-display-sm"
							as="h2"
							className="col-span-12 text-text-dark-text-1 lg:col-span-5"
						>
							{heading}
						</Typography>
					)}
					<div className="col-span-12 flex flex-col items-start gap-grid-section-vertical-md justify-self-stretch lg:col-start-7 lg:col-span-6">
						{intro && <Prose>{intro}</Prose>}
						<CustomerServiceForm topics={topics} content={content} consent={consent} />
					</div>
				</div>
			</Container>
		</section>
	);
};
